import { MemoryRouter } from 'react-router-dom';

import { useUser } from '../../store/context';
import { HomeScreenRoutes } from './HomeScreenRoutes';
import { RumRouteTracker } from '../../shared/RumRouteTracker';

export function HomeScreenRoute() {
  const { activeOrganization } = useUser();

  if (!activeOrganization) {
    return null;
  }

  const organizationId = activeOrganization.id;

  return (
    <MemoryRouter initialEntries={[`/${organizationId}`]}>
      <RumRouteTracker />
      <HomeScreenRoutes />
    </MemoryRouter>
  );
}
